import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary text-left" }, "Avançar para conciliação", -1)
const _hoisted_2 = { class: "flex flex-col gap-3 text-left" }
const _hoisted_3 = { class: "text-sm text-textPrimary" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-neutral50" }, " O envio para conciliação não pode ser desfeito. Cancele para continuar preenchendo a folha. ", -1)
const _hoisted_5 = { class: "flex flex-col sm:flex-row sm:justify-end gap-3" }

import { computed } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceDiscardEmptyRowsModal',
  props: {
    modelValue: { type: Boolean },
    saving: { type: Boolean },
    emptyRowCount: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit }) {

const props = __props;





// RN-10: o descarte das linhas vazias acontece exatamente neste clique e não aparece
// no payload — a confirmação é o que dá ciência dele ao auditor.
const emptyRowsMessage = computed(() => {
  if (props.emptyRowCount === 0) return 'Todas as linhas preenchidas serão enviadas à conciliação.'
  return props.emptyRowCount === 1
    ? '1 linha vazia não será enviada à conciliação.'
    : `${props.emptyRowCount} linhas vazias não serão enviadas à conciliação.`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[520px]",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(OutlineButton, {
          text: "Cancelar",
          width: "96px",
          height: "40px",
          "data-testid": "discard-empty-rows-cancel-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
        }),
        _createVNode(FilledButton, {
          text: "Confirmar avanço",
          class: "bg-primary30",
          width: "180px",
          height: "40px",
          disabled: _ctx.saving,
          "data-testid": "discard-empty-rows-confirm-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
        }, null, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(emptyRowsMessage.value), 1),
        _hoisted_4
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})